// extracted by mini-css-extract-plugin
module.exports = {"photo":"Photo_photo__3st0C","photo__img":"Photo_photo__img__3RWYD"};